export interface BannersConfig {
    color?: string;
    interval?: number;
    items?: BannerConfig[];
}


export interface BannerConfig {
    appId?: string;
    name?: string;
    src?: string;
    link?: string;
    startDate?: Date | string;
    endDate?: Date | string;
    visibility?: BannerVisibility;
    availableInCountries?: string[];
}

export enum BannerVisibility {
    all = 'all',
    clinic = 'clinic',
    lab = 'lab'
}